import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";

import "./Video.scss";

const Video = ({ videoString }) => {
  return (
    <div className="video-container">
      {parse(videoString)}
    </div>
  );
};

Video.propTypes = {
  videoString: PropTypes.string,
};

export default Video;
